var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fc0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 277H38v18h79l14-18zm-93 52h55l13-18H38v18zm117-86H38v19h104l13-19zm156-6l-16 23c-2 3-7 9 7 9h71l21-29c14-19 2-57-47-57H158l-32 45h181c9 0 9 3 4 9zm100 6l-13 18h76v-18h-63zm-50 42H249c-14 0-10-6-7-9l17-23c4-6 7-10-2-10h-82l-63 86h161c48 0 76-29 88-44zm12 10h101v-18h-88l-13 18zm-25 34h126v-18H362l-14 18z",
    fill: "#d40511",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.bcd1d2a47b5a952a5c9fe4c29a1c51ed.svg";
export { ForwardRef as ReactComponent };